import actions from './actions';
import { merge } from '../../../utils/state';

const initialState = {
  storeScrollCoordinates: {},
  isRebrand: false,
  orgAssociations: {},
};

export default function reducer(state = initialState, action = {}) {
  const { payload, type } = action;

  switch (type) {
    case actions.TYPES.STORE_SCROLL_LOCATION:
      return merge(state, {
        storeScrollCoordinates: payload,
      });
    case actions.TYPES.SET_REBRAND:
      return merge(state, {
        isRebrand: payload,
      });
    case actions.TYPES.SET_ORG_ASSOCIATION:
      return merge(state, {
        orgAssociations: {
          ...state.orgAssociations,
          ...payload,
        },
      });
    default:
      return state;
  }
}
